import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { HttpInterceptor } from './shared/index';
import { CONSTANT_VALUES } from './constants/constant-values';
import { Router } from '@angular/router';
import 'rxjs/add/operator/share';
import { ActivatedRoute } from '@angular/router';
import { HandleSideMenuWithAuth, FacilityListEvent, LoaderEvent } from './shared/message.event';
import { environment } from '../environments/environment';


@Injectable()
export class AppService {
    nameChange: Subject<string> = new Subject<string>();
    private shouldSlide: boolean = false;
    private _router;
    public showPopup;
    private authGuard: Object = {
        'signup': [CONSTANT_VALUES.SUPER_ADMIN],
        'facility': [CONSTANT_VALUES.SUPER_ADMIN],
        'addfacility': [CONSTANT_VALUES.SUPER_ADMIN],
        'addmember': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'member': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'calendar': [CONSTANT_VALUES.ROLE_STAFF, CONSTANT_VALUES.ROLE_VENDOR_ADMIN, CONSTANT_VALUES.SUPER_ADMIN],
        'logout': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN, CONSTANT_VALUES.ROLE_STAFF, CONSTANT_VALUES.SUPER_ADMIN],
        'creategroup': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'disablemember': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'memberdetail': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'activemember': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'feedback': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'group': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'managegroup': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'feedbacklist': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'broadcast': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'alert': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'feed': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN]
    };

    private defaultRouteForRole = {
        'vendor admin': 'member',
        'staff': 'calendar',
        'superAdmin': 'facility'
    };
    private popUp: any;
    private facilityData: any;
    private appVersion: any;
    private memberDetail;

    constructor(private http: HttpInterceptor, private router: Router, private route: ActivatedRoute,
        public handleSideMenuWithAuth: HandleSideMenuWithAuth, private facilityListEvent: FacilityListEvent,
        private loaderEvent: LoaderEvent) {
        this._router = router;
    }


    storeFacility(facilitydata): void {
        localStorage.setItem('facility', btoa(JSON.stringify(facilitydata)));
    }
    getFacility() {
        return atob(localStorage.getItem('facility'));
    }

    logout(): void {
        localStorage.clear();
    }

    setShouldSlide(state): void {
        this.shouldSlide = state;
    }

    getShouldSlide(): boolean {
        return this.shouldSlide;
    }

    getClubFacility(vendorObj) {
        let url = CONSTANT_VALUES.URL_FACILITY_LIST_BY_VENDOR;
        return new Promise((resolve, reject) => {
            this.http.post(url, vendorObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
    setCategoryForCalendar(category): void {
        localStorage.setItem('category', btoa(JSON.stringify(category)));
    }

    getCategoryForCalendar() {
        if (localStorage.getItem('category')) {
            return atob(localStorage.getItem('category'));
        } else {
            return null;
        }
    }

    getMemberDetail(memberdetailObj) {
        let url = CONSTANT_VALUES.URL_GET_MEMBER_DETAIL;
        return new Promise((resolve, reject) => {
            this.http.post(url, memberdetailObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    getVendorRole() {
        let vendorData = localStorage.getItem('vendor');
        if (vendorData) {
            let vendor = JSON.parse(atob(vendorData));
            return vendor.role;
        } else {
            return false;
        }
    }

    getFacilityByClub(vendorId) {
        let vendorObj = {
            vendorId: vendorId
        };
        this.loaderEvent.fire(false);
        let that = this;
        this.getClubFacility(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.facilityData = result.facilityData;
                this.facilityListEvent.fire(this.facilityData);
                localStorage.setItem('vendor_facilityData', btoa(JSON.stringify(this.facilityData)));
            } else {
            }
            this.loaderEvent.fire(true);
        }).catch((err) => {
            console.log(err);
            this.loaderEvent.fire(true);
            return err;
        });
    }

    getAppVersion() {
        let that = this;
        let requestObj = {
            'keys': ['passwordEncryptionKey', 'appVersions', 'timezoneCountries','timezoneCodes'],
        }
        let url = CONSTANT_VALUES.URL_GET_MASTER_DATA_DETAIL;
        return new Promise((resolve, reject) => {
            this.http.post(url, requestObj).map((res) => res.json()).subscribe(data => {
                data.appVersions.forEach(rec => {
                    if (rec['deviceType'] === 'WEB') {
                        that.appVersion = rec['currentVersion'];
                        resolve({
                            'appVersion': that.appVersion,
                            'ASE_KEY': data.passwordEncryptionKey,
                            'timezoneCountries':data.timezoneCountries,
                            'timezoneCodes':data.timezoneCodes
                        });
                    }
                });
            });
        });
    }

    getListOfGroup(vendorObject) {
        let url = CONSTANT_VALUES.URL_ALL_GROUP;
        return new Promise((resolve, reject) => {
            this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    getFacilityList(vendorId) {
        try {
            let vendorForFacilityList = { 'vendorId': vendorId };
            let url = CONSTANT_VALUES.URL_GET_FACILITY_LIST_VENDOR;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorForFacilityList).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    getListOfMember(vendorObject) {
        try {
            let url = CONSTANT_VALUES.URL_GET_MEMBER_VENDOR;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    getActivityListByVendor(vendorObject) {
        try {
            let url = CONSTANT_VALUES.GET_CATEGORIES_FOR_FEEDBACK;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    storeMemberDetail(memberObj) {
        //  var d = new Date();
        //  d.setTime(d.getTime() + (exdays*24*60*60*1000));
        // var expires = "expires=" + d.toGMTString();
        document.cookie = 'memberObjs' + "=" + JSON.stringify(memberObj) ;
        this.memberDetail = memberObj;
    }
    showMemberDetail() {

        let name = 'memberObjs';
        let m;
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                m = c.substring(name.length, c.length);
            }
        }
        //m = JSON.parse(m);
        return this.memberDetail;
    }

    serviceErrorHandler(){
        this.loaderEvent.fire(true);
        this.showPopup.showChildModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/app.service.ts